const data = {
  func: {
    bottomLink: [
      { name: "京东商城", link: "https://www.jd.com/" },
      { name: "京东数科", link: "https://www.jddglobal.com/" },
      { name: "京东物流", link: "https://www.jdwl.com/" },
      { name: "京东云", link: "https://www.jdcloud.com/" },
      { name: "京东AI", link: "https://neuhub.jd.com/" },
      { name: "京东企业购", link: "https://b.jd.com/" },
      { name: "京东商用", link: "https://shang.jd.com/" },
      { name: "京东工业品", link: "https://mro.jd.com/" },
    ],
    bottomInfo: [
      {
        name: "Copyright © 2022 京东企业业务",
        backIcon: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
      },
      {
        name: "备案号：京ICP备11041704号-43",
        backIcon: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
      },
    ],
  },
  style: {},
  data: {},
};
export default data;
